export default __webpack_public_path__ + "static/media/sample.2adecfd8.jpg";